<template>
    <el-dialog title="查看仓库信息" :visible.sync="visible" append-to-body v-dialogDrag width="400px"
        :close-on-click-modal="false">
        <el-form :model="form" status-icon ref="form" label-position="right" label-width="100px">
            <el-row :gutter="10">
                <!-- <el-col :span="24">
                    <el-form-item label="所属机构" prop="CompanyName">
                        <div class="text" :title="form.CompanyName">
                            {{ form.CompanyName }}
                        </div>
                    </el-form-item>
                </el-col> -->
                <el-col :span="24">
                    <el-form-item label="物料编号" prop="ScrapId">
                        <div class="text" :title="form.ScrapId">
                            {{ form.ScrapId }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="物料名称" prop="ScrapName">
                        <div class="text" :title="form.ScrapName">
                            {{ form.ScrapName }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="单位" prop="Unit">
                        <div class="text" :title="form.Unit">
                            {{ form.Unit }}
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer">
            <el-button type="canale" @click="visible = false">关 闭</el-button>
        </span>
    </el-dialog>
</template>
    
<script>
export default {
    props: ["item"],
    components: {
    },
    data() {
        return {
            visible: false,
            loading: false,
            isable: true,
            isEdit:false,
            form: {},
        };
    },
    computed: {
    },
    watch: {
        item: {
            handler: function (v) {
            if (v.ScrapId) {
                this.isEdit = true;
                this.$get("VehicleScrap/GetModel", {
                    ScrapId: v.ScrapId,
                }).then((r) => {
                    this.init({ ...r.Result });
                });
            } else {
                this.init({}); 
                this.isEdit = false;
            }
                this.visible = true;
            },
        },
    },
    methods: {
        init(form) {
            this.form = { ...form };
            if (this.$refs["form"]) {
                this.$refs["form"].resetFields();
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/themes/common";

h4 {
    margin-top: 10px;
    @include font_color("text-color2");
}
</style>